module.exports = __webpack_public_path__ + "img/c15.b77e6fc8.png";